











































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import workTime from './sla/workTime/index.vue';
import raiseNoticeSetting from './sla/raise-notice-setting.vue';
import nonWorking from './sla/nonWorking.vue';
import preRemindSetting from './sla/pre-remind-setting.vue';
import level from './sla/level.vue';

type TabName = 'level' | 'workTime' | 'nonWorking' | 'raiseNotice' | 'preRemindNotice';

const sanitilizeTab = (tabQuery: any) => {
    if (['level', 'workTime', 'raiseNotice', 'nonWorking', 'preRemindNotice'].includes(tabQuery)) {
        return tabQuery;
    }
    return 'level';
};

/**
 * sla设置
 *
 * @author liyuyao
 * @date 01/11/2019
 */
@Component({
    components: {
        workTime,
        raiseNoticeSetting,
        nonWorking,
        level,
        preRemindSetting
    }
})
export default class RgSla extends Vue {
    @State(state => state.cti.permission.rg_report)
    permission: boolean;

    activeTab: TabName = null;

    created() {
        const initialTab = sanitilizeTab(this.$route.query.tab);
        this.activeTab = initialTab;
        this.changeTabQuery(initialTab);
    }

    changeTabQuery(tab: string) {
        this.$router
            .push({
                query: {
                    ...this.$route.query,
                    tab
                }
            })
            .catch(e => e);
    }

    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }

    handleTabClick(_: MouseEvent, tab: { value: TabName }) {
        this.changeTabQuery(tab.value);
    }
}
